import { render, staticRenderFns } from "./taskboard.vue?vue&type=template&id=e03e99a0&scoped=true&"
import script from "./taskboard.vue?vue&type=script&lang=js&"
export * from "./taskboard.vue?vue&type=script&lang=js&"
import style0 from "./taskboard.vue?vue&type=style&index=0&id=e03e99a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e03e99a0",
  null
  
)

export default component.exports